module.exports = __webpack_public_path__ + "media/entities/1301-a3f38c84.png";